// extracted by mini-css-extract-plugin
module.exports = {"span":"Span_span__yebUB","highlighted":"Span_highlighted__Rpr92","spin":"Span_spin__EC4_f","loader":"Span_loader__SR9gO"};